import { PortableAPI } from './portable-api'

export class KoreaProfileRefresh extends PortableAPI {
	private _customerID: string
	public getInterface(): Promise<unknown> {
		return this.fetchKoreaProfile()
	}

	private async fetchKoreaProfile(): Promise<unknown> {
		await window.gbpe.auth.loaded
		// Error handling
		// Reject promise when user is unauthenticated
		if (window.gbpe.auth.currentAuthState !== 1) {
			return Promise.reject('User is unauthenticated !!!')
		}
		if (this._url === '' || this._url == undefined) {
			return Promise.resolve('Fetch Korea Profile Disabled for this Navigation: Cancelling API Call...')
		}

		const requestParams = await this.requestParameters()
		return new Promise<unknown>((resolve, reject) => {
			this._fetchPromise = this._mockEnabled ? new Promise(this.getMockData()) : fetch(this._url, requestParams)
			this._fetchPromise
				.then(resp => {
					//Adding check to for response status is 201 in case of API Response for Korea endpoints via proxy
					if (resp && (resp['status'] === 200 || resp['status'] === 201)) {
						return resp
					}
					throw this.createError('Network error')
				})
				.catch(() => {
					throw this.createError('Network error')
				})
				.then(async resp => {
					const respJson = await resp['json']()
					const ccInstance = new this[this._carbonCopyClassName](this, respJson, this._dependentInstance)
					resolve(ccInstance)
					this._lookupPromise = null
					console.log('API call for item :' + this._item)
				})
				.catch(error => {
					this.createError(error)
					reject(error)
				})
		})
	}

	//TODO: When final API Pathing decided, May Need to Update Params in Call.
	protected async requestParameters(): Promise<RequestInit> {
		const tokens = await window.gbpe.auth.getValidTokens?.()
		const idToken = tokens?.idToken || window.gbpe.auth.idToken || ''
		const headers: HeadersInit = new Headers({
			Authorization: idToken,
			locale: window.gbpe.config.locale,
			region: window.gbpe.config.region,
		})
		return {
			method: 'GET',
			headers,
		}
	}
}
